import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { ShowEventSelector } from 'components/showEventSelector'
import { useEventById } from 'hooks/admin/useEvents'
import { useEventsUser } from 'hooks/user/useEvents'
import { useEffect } from 'react'
import { EventDetails, EventType } from 'types/Event'

interface Props {
    showId: string
    onSelect?: (event: EventDetails | null) => void
}

export const SelectEvent = ({ showId, onSelect }: Props) => {
    const { data: events, isLoading: isLoadingEvents, error: eventsError } = useEventsUser()

    const selectedEvent = events
        ? events
              .filter((event: EventType) => event.show_id === showId)
              .filter((event: EventType) => new Date(event.event_date) > new Date())
              .sort((a, b) => new Date(a.event_date).getTime() - new Date(b.event_date).getTime())
              .shift()
        : undefined

    const { data: currentEvent, isLoading: isLoadingEvent, error: eventError } = useEventById(selectedEvent?.event_id || '')

    const isLoading = isLoadingEvents || isLoadingEvent
    const error = eventsError || eventError

    useEffect(() => {
        if (onSelect && currentEvent) onSelect(currentEvent)
    }, [currentEvent, onSelect])

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            {currentEvent ? (
                <ShowEventSelector
                    currentEvent={currentEvent}
                    events={events || []}
                    title="Következő előadás"
                    redirectUrl="/jegyek/vasarlas"
                    topPurchaseButton
                    openByDefault
                />
            ) : (
                <PlaceholderContainer>
                    <p>Hamarosan érkezünk újabb előadásokkal!</p>
                </PlaceholderContainer>
            )}
        </LoadingContainer>
    )
}
